import getWebinarPreview from '@anm/helpers/getWebinarPreview';
import { useSelector } from 'react-redux';
import { streamSelectors } from '../../../../../../store/modules/stream';

import config from '../../../../../../config';
import useIsWebinar from '../../../../../../hooks/useIsWebinar';
import { Sizes } from '@anm/components/SizeInputs';

type HookProps = {
  hostId: string;
  videoSizes: Sizes;
};

const useEmailThumbPreview = ({ hostId, videoSizes }: HookProps) => {
  const stream = useSelector(streamSelectors.selectStream);
  const isWebinar = useIsWebinar();

  const previewSrc =
    isWebinar && stream?.state === 'SCHEDULED'
      ? getWebinarPreview({ previewUrl: stream?.meta.preview, isVertical: videoSizes.width / videoSizes.height < 1 })
      : `${config().urls.embed}${hostId}/preview.jpg`;

  return previewSrc;
};

export default useEmailThumbPreview;
